<script setup lang="ts">
import AppButton from '@/application/components/ui/AppButton.vue';
import FaIcon from '@/application/components/ui/FaIcon.vue';
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

interface Props {
  zoomIn: (() => void)|null,
  zoomOut: (() => void)|null,
  download: () => Promise<void>,
  filename: string,
}

defineProps<Props>();
const emit = defineEmits(['close']);
</script>

<template>
  <div class="sticky z-[2005] left-0 top-0 w-full px-4 py-2 shadow-md bg-white overflow-hidden">
    <div class="grid grid-cols-3 align-items-center h-8">
      <div class="text-left flex flex-row items-center">
        <div class="truncate text-blue-500">{{ filename }}</div>
        <AppButton type="primary" text circle class="ml-2 shadow-none" :handler="download">
          <FaIcon name="download" />
        </AppButton>
      </div>
      <div class="text-center">
        <AppButton v-if="zoomIn" type="primary" text circle class="shadow-none" @click="zoomIn">
          <FaIcon name="plus" />
        </AppButton>
        <AppButton v-if="zoomOut" type="primary" text circle class="shadow-none" @click="zoomOut">
          <FaIcon name="minus" />
        </AppButton>
      </div>
      <div class="text-right">
        <AppButton type="primary" text class="shadow-none close-button" @click="emit('close')">
          <FontAwesomeIcon transform="grow-10" fixed-width icon="times" />
        </AppButton>
      </div>
    </div>
  </div>
</template>

<style scoped>
.close-button :deep(button) {
  padding-inline: calc(var(--spacing) * 2);
}
</style>
